<template>
    <div class="service-details">
      <h1>Service Details</h1>
      <div v-if="service">
        <p><strong>Name:</strong> {{ service.name }}</p>
        <p><strong>Description:</strong> {{ service.description }}</p>
        <p><strong>Status:</strong> {{ service.status }}</p>
        <!-- Add more service details here as needed -->

        <button @click="updateService" class="btn btn-primary">Update Service</button>
        <button @click="deleteService" class="btn btn-danger">Delete Service</button>
      </div>
      <div v-else>
        <p>Loading service details...</p>
      </div>
    </div>
  </template>

  <script>
  import axios from 'axios';

  export default {
    name: 'ServiceDetails',
    props: {
      id: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        service: null,
      };
    },
    created() {
      this.fetchServiceDetails();
    },
    methods: {
      async fetchServiceDetails() {
        try {
          const response = await axios.get(`/api/services/${this.id}`);
          this.service = response.data;
        } catch (error) {
          console.error('Error fetching service details:', error);
        }
      },
      async updateService() {
        try {
          // Implement the logic to update the service details here
          // For example, show a form to edit the service details and send a request to the server
          const response = await axios.put(`/api/services/${this.id}`, this.service);
          this.service = response.data;
          alert('Service updated successfully');
        } catch (error) {
          console.error('Error updating service:', error);
        }
      },
      async deleteService() {
        try {
          await axios.delete(`/api/services/${this.id}`);
          alert('Service deleted successfully');
          this.$router.push({ name: 'tenantservices.index' });
        } catch (error) {
          console.error('Error deleting service:', error);
        }
      }
    }
  };
  </script>

  <style scoped>
  .service-details {
    padding: 20px;
  }

  .btn {
    margin-right: 10px;
  }

  .btn-primary {
    color: #fff;
    background-color: #007bff;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    text-decoration: none;
  }

  .btn-primary:hover {
    background-color: #0056b3;
  }

  .btn-danger {
    color: #fff;
    background-color: #dc3545;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    text-decoration: none;
  }

  .btn-danger:hover {
    background-color: #c82333;
  }
  </style>
